import { Box, Button } from '@mui/material';
import { TEXTS } from '../../../core/texts';
import { useCallback, useContext, useMemo } from 'react';
import { FreelancerContext, VIEW_QUERY_PARAM_KEY } from './FreelancerEntity';
import { useSearchParams } from 'react-router-dom';
import BullhornProfileModal from '../BullhornProfileModal';
import { AccountBox } from '@mui/icons-material';

const BULLHORN_QUERY_PARAM = 'bullhorn';

const ProfileBullhorn = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const bullhornView = useMemo(() => searchParams.get(VIEW_QUERY_PARAM_KEY) === BULLHORN_QUERY_PARAM, [searchParams]);
  const { user } = useContext(FreelancerContext);
  const openModal = useCallback(() => {
    searchParams.set(VIEW_QUERY_PARAM_KEY, BULLHORN_QUERY_PARAM);
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);
  const closeModal = useCallback(() => {
    searchParams.delete(VIEW_QUERY_PARAM_KEY);
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return (
    <Box>
      <Button onClick={openModal} variant={'outlined'} startIcon={<AccountBox color={'primary'}/>}>
        {TEXTS.BULLHORN_PROFILE}
      </Button>
      {
        bullhornView &&
        <BullhornProfileModal onClose={closeModal} freelancer={user}/>
      }
    </Box>
  );
};

export default ProfileBullhorn;